<template>
  <div class="courses-page">
    <div class="container">

    <h2>الكورسات</h2>
    <div class="courses-grid">
      <CourseCard 
        v-for="course in courses" 
        :key="course.id" 
        :course="course" 
        @watch="goToCourse(course.id)"
      />
    </div>
            
    </div>
  </div>
</template>

<script>
import CourseCard from "@/components/CoursesPage/CourseCard.vue";
import apiService from "@/apiService";

export default {
  name: 'Courses Page',
  components: { CourseCard },
  data() {
    return {
      courses: []
    };
  },
  async mounted() {
    try {
      const response = await apiService.getLatestCourses();
      console.log("Courses response:", response);
      this.courses = response.data.courses || response.data.data || [];
    } catch (error) {
      console.error("error fetching courses:", error);
    }
  },
  methods: {
    goToCourse(id) {
      this.$router.push(`/courses/${id}`);
    },
  }
};
</script>

<style scoped>
.courses-grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, minmax(280px, 1fr));
  gap: 40px;
  margin: 0 auto; 
}
.courses-page {
    background-color: #FFEFD6;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 200px 20px;
}
.courses-page h2 {
    text-align: center;
    font-weight: 500;
    font-size: 40px;
    padding-bottom: 25px;
}
@media (max-width: 992px) {
  .courses-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 576px) {
  .courses-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

}
</style>
